import React from "react";
import { Redirect } from "react-router-dom";
import * as routeHelpers from "./routeHelpers";

export function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function buildRouteWithAuthParams(route, params) {
  const search = buildAuthenticationRouteParams(getAuthenticationParams(params));
  const pathname = routeHelpers.buildRoute(route);
  return { pathname: pathname, search: search };
}

export function buildAuthenticationRouteParams({ verificationCode, ecrId }) {
  if (!verificationCode && !ecrId) return '';
  const ecrIdParam = ecrId ? `ecrId=${ecrId}` : '';
  const cParam =
    verificationCode
      ? ecrId
        ? `&c=${verificationCode}`
        : `c=${verificationCode}`
      : '';
  return `?${ecrIdParam}${cParam}`;
}

export function getAuthenticationParams(params) {
  const verificationCode = params.get('c');
  const ecrId = params.get('ecrId');
  return { verificationCode, ecrId };
}


export function getAccountUniqueNameFromUrl() {
  let urlSegments = window.location.href.split("/");

  if (urlSegments.length > 3)
    return urlSegments[3].includes('?') ? //check if there is a need to remove params
      urlSegments[3].substring(0, urlSegments[3].indexOf('?'))
      : urlSegments[3];
  else return null;
}

export function checkErrorResponseForRedirect(response) {
  if (response?.status === 401) {
    if (!response?.headers['oauth-custom-security-authorizationerror']) {
      clearSession();
      return routeHelpers.buildRoute('/login');
    }
    switch (response?.headers['oauth-custom-security-authorizationerror']) {
      case 'NOT_AUTHENTICATED':
        clearSession();
        return routeHelpers.buildRoute("/login");
      case "REGISTRATION_REQUIRED":
        const verificationCode = getParameterByName('c');
        const ecrId = getParameterByName('ecrId');
        const paramsRoute = buildAuthenticationRouteParams({ verificationCode, ecrId })

        //if (!verificationCode) window.location = routeHelpers.buildRoute(`/login/reset-unlock-code${paramsRoute}`);
        //else if (verificationCode) window.location = routeHelpers.buildRoute(`/login/verification${paramsRoute}`);

        window.location = routeHelpers.buildRoute(`/login/verification${paramsRoute}`);
        break;
      case "UNAVAILABLE_PROVIDER":
        return routeHelpers.buildRoute(`/login/reset-unlock-code`);
      case "UNAUTHORIZED":
        // TODO show error but don't go back to login - someone must give you permission
        break;
      default:
        return null;
    }
  }
  return null;
}

export function getAuthUser() {
  return JSON.parse(localStorage.getItem("AUTH_USER"));
}

export function getAuthUserName() {
  var user = getAuthUser();
  return user ? user.name : "";
}

export function setAuthUser(user) {
  localStorage.setItem("AUTH_USER", JSON.stringify(user));
}

export function logout() {
  clearSession();
  return <Redirect to={routeHelpers.buildRoute("/login")} />;
}

export function clearSession() {
  localStorage.clear();
}
